import React from 'react';

import isCreateAnalysisEnabled from 'analysis-tool/isCreateAnalysisEnabled';
import * as ArchiveActions from 'archive/ArchiveActions';
import ArchiveOrUnarchiveButton from 'archive/components/buttons/ArchiveOrUnarchiveButton';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Grid} from 'constants/SampleConstants';
import PrintLabelButton from 'label-printing/PrintLabelButton';
import SendPlateToAnalysisButton from 'samples/grids/SendPlateToAnalysisButton';
import ChangeParentStorableButton from 'samples/storables/ChangeParentStorableButton';
import {SetParentStorableHandler} from 'samples/storables/ParentStorableTypes';
import StorableExportButton from 'samples/storables/StorableExportButton';
import {PlateSchemaType} from 'samples/storables/StorableSchemaConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import APIUtil from 'util/APIUtil';
import {typeToName} from 'util/NameUtil';
import AddToWorklistButton from 'worklists/AddToWorklistButton';

export interface GridToolbarProps {
  grid: Grid;
  onSetParentStorable: SetParentStorableHandler;
}

export default function GridToolbar({grid, onSetParentStorable}: GridToolbarProps): JSX.Element {
  const buttonStyle = ButtonStyle.TERTIARY_BLUE;
  const gridType = APIUtil.apiIdToType(grid.id);
  const gridName = typeToName(gridType);
  return (
    <div className="buttonToolbar">
      {grid.permissions.writable && (
        <div className="buttonGroup">
          <ChangeParentStorableButton
            isWritable={grid.permissions.writable}
            onSetParentStorable={onSetParentStorable}
            waitForSubmitErrors={true}
            storableSchema={grid.storableSchema}
          />
        </div>
      )}
      <div className="buttonGroup">
        <PrintLabelButton buttonStyle={buttonStyle} itemIds={[grid.id]} />
        {BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS && gridType === ModelTypeConstants.PLATE && (
          <AddToWorklistButton
            className="u-mini-spacing-left"
            buttonStyle={ButtonStyle.TERTIARY_BLUE}
            ids={[grid.id]}
            refreshOptions={{refreshRecentWorklists: true}}
          />
        )}
        {BenchlingConfig.ENABLE_SCRATCH_PLATES &&
          isCreateAnalysisEnabled() &&
          gridType === ModelTypeConstants.PLATE &&
          grid.storableSchema.plateSchemaType === PlateSchemaType.FIXED_PLATE && (
            <SendPlateToAnalysisButton
              className="u-mini-spacing-left"
              buttonStyle={buttonStyle}
              plateId={grid.id}
            />
          )}
        <ArchiveOrUnarchiveButton
          archiveTooltipTitle={`Archive ${gridName}`}
          unarchiveTooltipTitle={`Unarchive ${gridName}`}
          buttonStyle={buttonStyle}
          isArchivable={Boolean(grid.permissions.archivable)}
          isUnarchivable={Boolean(grid.permissions.unarchivable)}
          item={grid}
          onArchive={ArchiveActions.bulkArchiveStorablesWithDataMods}
          onUnarchive={ArchiveActions.bulkUnarchiveStorablesWithDataMods}
        />
        <StorableExportButton storableId={grid.id} buttonStyle={buttonStyle} />
      </div>
    </div>
  );
}
